BaseManager = require 'BaseManager'
networkManager = require 'networkManager'
Polyglot = require 'polyglot'
log = require 'loglevel'

###############################################

class LocaleManager extends BaseManager

  name: 'LocaleManager'
  defaultLanguage: 'en'
  hasDefaultLanguage: false

  # -------------------------------------------

  constructor: ->
    log.info @name, 'constructor'

    @polyglot = new Polyglot({
      warn: (m) -> console.warn(m)
    })

    window.__t = @

  # -------------------------------------------

  clearLanguages: ->
    @polyglot.clear()
    # @polyglot.allowMissing = false
    @hasDefaultLanguage = false

  # -------------------------------------------

  setLanguage: (languageCode, callback) ->

    # if we have a default or this is the default
    if @hasDefaultLanguage or languageCode is @defaultLanguage
      @_setLanguage languageCode, (lang, err) =>
        @hasDefaultLanguage = true
        callback lang, err if callback?

    # add default then lang
    else
      @clearLanguages()
      @_setLanguage @defaultLanguage, (lang, err) =>
        @hasDefaultLanguage = true
        @_setLanguage languageCode, (lang, err) =>
          callback lang, err if callback?

  # -------------------------------------------

  _setLanguage: (languageCode, callback) ->

    baseLangCode = @_getBaseLang languageCode

    log.info @name, '_setLanguage', baseLangCode

    # get base
    @_getLanguage baseLangCode, (json,err) =>
      unless err?
        @polyglot.extend json
        @polyglot.locale(languageCode)

      # is this an extended code
      if @_isBaseLang languageCode
        return callback(languageCode)

      # get extended
      @_getLanguage languageCode, (json,err) =>
        unless err?
          @polyglot.extend json
          @polyglot.locale(languageCode)
        callback(languageCode)

  # -------------------------------------------

  _getLanguage: (languageCode, callback) ->

    log.info @name, '_getLanguage', languageCode

    try
      path = require 'lang/' + languageCode + '.json'
    catch e
      return callback()

    networkManager.getJSON path, (json, err, code) =>
      if json? and not err?
        callback(json, null) if callback?
      else
        callback(null, err) if callback?
        console.error 'Lang file failed to load: ' + err, code

  # -------------------------------------------

  str: (string, vars=null, comment=null) ->
    @polyglot.t string, vars

  # -------------------------------------------

  html: (template) ->

    template.replace /'''([^\0]+?)'''/gm, (match, key) =>

      localizedString = @str(key)
      localizedString

  # -------------------------------------------

  _isBaseLang: (langCode) ->

    (langCode.length <= 2)

  # -------------------------------------------

  _getBaseLang: (langCode) ->

    langCode.substr(0,2)

  # -------------------------------------------

module.exports = LocaleManager.getInstance()



// WEBPACK FOOTER //
// ./coffee/manager/locale-manager.coffee